// src/router.js
import { createRouter, createWebHistory } from 'vue-router'
import { useAppStore } from './stores/app'
import { useTaskStore } from './stores/task'
import { useAnalyticsStore } from './stores/analytics'
import { useSettingsStore } from './stores/settings'
import { isRPilotEnabledForApiUrl } from './config/rpilotWhitelist'
import UpdateSchedulePage from './components/UpdateSchedulePage.vue'
import RestorePage from './components/RestorePage.vue'
import CreateSchedulePage from './components/CreateSchedulePage.vue'
import NoPermissionsPage from './components/NoPermissionsPage.vue'
import LinkExistingItemsPage from './components/LinkExistingItemsPage.vue'
import RPilotPage from './components/RPilotPage.vue'
import TaskSetProfileUpdatePage from './components/TaskSetProfileUpdatePage.vue'
import TaskSetProfileCreatePage from './components/TaskSetProfileCreatePage.vue'
import RPilotTaskSetProfilePage from './components/RPilotTaskSetProfilePage.vue'


const routes = [
  {
    path: '/',
    name: 'Root',
    component: {
      template: '<div></div>'
    }
  },
  { path: '/schedules/update', name: 'Update', component: UpdateSchedulePage },
  { path: '/schedules/restore', name: 'Restore', component: RestorePage },
  { path: '/schedules/create', name: 'Create', component: CreateSchedulePage },
  { path: '/schedules/link', name: 'Link', component: LinkExistingItemsPage },
  { path: '/rpilot', name: 'RPilot', component: RPilotPage },
  // Task Set Profile routes
  { path: '/taskset-profiles/update', name: 'TSPUpdate', component: TaskSetProfileUpdatePage },
  { path: '/taskset-profiles/create', name: 'TSPCreate', component: TaskSetProfileCreatePage },
  { path: '/taskset-profiles/rpilot', name: 'TSPRPilot', component: RPilotTaskSetProfilePage },
  { path: '/no-permissions', name: 'NoPermissions', component: NoPermissionsPage }
]

const RPILOT_ROUTE_NAMES = new Set(['RPilot', 'TSPRPilot'])

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard to redirect Root to default route and reset page state
router.beforeEach((to, from, next) => {
  // Reset tasks when navigating between pages
  if (from.name && from.name !== to.name) {
    const taskStore = useTaskStore()
    taskStore.resetPageState()
  }

  // RPilot routes are only available on whitelisted API hosts. Deep links land
  // before App.vue has parsed the embed query string into the settings store,
  // so prefer the raw `apiUrl` query param and fall back to the store.
  const appStore = useAppStore()
  if (RPILOT_ROUTE_NAMES.has(to.name)) {
    const queryApiUrl = new URLSearchParams(window.location.search).get('apiUrl')
    const apiUrl = queryApiUrl || useSettingsStore().settings.apiUrl
    if (!isRPilotEnabledForApiUrl(apiUrl)) {
      next(appStore.defaultRoute ? { name: appStore.defaultRoute, replace: true } : { name: 'Root', replace: true })
      return
    }
  }

  // If navigating to Root and we have a default route, redirect
  if (to.name === 'Root' && appStore.defaultRoute) {
    next({ name: appStore.defaultRoute, replace: true })
  } else {
    next()
  }
})

router.afterEach((to) => {
  const analyticsStore = useAnalyticsStore()
  analyticsStore.trackPage({
    pageUrl: to.fullPath
  })
})

export default router